const peppolPartyRegistration = {
  PeppolParty: "Parte Peppol",
  peppol_party_registration: "Registro de Parte Peppol",
  add_configuration: "Registrar Entidad Peppol",
  edit_configuration: "Editar Entidad Peppol",
  company_id: "ID de empresa",
  select_company_id: "Seleccionar ID de empresa",
  country: "País",
  tax_registration_number: "Número de registro fiscal",
  name: "Nombre",
  email: "Correo electrónico",
  status: "Estado",
  registered: "Registrado",
  pending: "Pendiente",
  processing: "Procesando",
  failed: "Fallido",
  created_on: "Creado el",
  updated_on: "Actualizado el",
  peppol_participant_id: "ID de participante Peppol",
  scheme_id: "ID de esquema",
  cancel: "Cancelar",
  create: "Crear",
  update: "Actualizar",
  edit: "Editar",
  delete: "Eliminar",
  actions: "Acciones",
  configuration: "Configuración",
  Dashboard: "Panel de control",
  something_went_wrong: "Algo salió mal",
  no_peppol_parties_found: "No se encontraron partes Peppol",
  no_peppol_inbox_found: "No se encontró ninguna bandeja de entrada de Peppol.",
  peppol_party_created_successfully: "Parte Peppol registrada exitosamente",
  peppol_party_updated_successfully: "Parte Peppol actualizada exitosamente",
  peppol_party_deleted_successfully: "Parte Peppol eliminada exitosamente",
  delete_peppol_party_title: "Eliminar Parte Peppol",
  delete_peppol_party_description:
    "¿Estás seguro de que deseas eliminar este registro de parte Peppol?",
  company_id_required: "El ID de empresa es obligatorio",
  country_required: "El país es obligatorio",
  tax_registration_number_required:
    "El número de registro fiscal es obligatorio",
  name_required: "El nombre es obligatorio",
  email_required: "El correo electrónico es obligatorio",
  email_invalid: "Ingrese una dirección de correo electrónico válida",
  legal_representative_missing_text:
    "No se encontró representante legal, por favor",
  update_first: "actualiza primero",
  "legal_representative_not_found": "Representante legal no encontrado, actualice primero",
  "party_registration_in_processing": "El registro de la parte está en proceso",
  "party_not_found": "Parte Peppol no encontrada",
  "party_not_registered": "La parte Peppol no está registrada",
  "party_already_registered": "La parte Peppol ya está registrada",
  "party_configuration_not_found": "No se encontró la configuración de la parte Peppol",
  "party_registration_id_not_found": "No se encontró el ID de registro de la parte Peppol",
  "register_party_for_approval": "Registrar parte para aprobación",
  "set_state": "Establecer estado",
  "notify_failure": "Notificar fallo",
  "unregister_peppol_party": "Anular registro de la parte Peppol",
  "notify_unregister": "Notificar anulación de registro",
  proof_of_ownership: "Prueba de propiedad",
  proof_of_ownership_required: "Se requiere prueba de propiedad",
  proof_of_ownership_invalid: "Tipo de archivo inválido. Solo se permiten archivos PDF.",
  unregister: "Darse de baja",
  unregistered: "Dado de baja",
  unregister_party: "Darse de baja de la Parte Peppol",
  unregister_party_description: "¿Está seguro de que desea darse de baja de esta parte Peppol?",
  unregistration_processing: "Procesando baja",
  unregistration_failed: "Error en la baja",
  enter_unregistration_reason: "Ingrese la razón para darse de baja",
  reason_required: "Se requiere una razón para darse de baja",
  peppol_party_unregistered_successfully: "Parte Peppol dada de baja exitosamente",
  confirm_unregistration: "Confirmar baja",
  confirm_unregistration_description: "¿Está seguro de que desea continuar con la baja?",
  history: "Ver historial",
  job_history: "Historial del trabajo",
  execution_path: "Ruta de ejecución",
  no_history_found: "No se encontró historial",
  provider: "Proveedor",
  message: "Mensaje",
  close: "Cerrar",
  success: "Éxito",
  running: "En ejecución",
};

export default peppolPartyRegistration;
